import { http } from '@pendo/http';

export function createDestination (destination) {
    const { type } = destination;

    if (type === 'databricks') {
        return http.post('/api/s/_SID_/datasync/destinations', destination);
    }

    const {
        bucketUrl,
        secretKey,
        serviceAccount,
        status,
        tenantId,
        roleId,
        provider,
        region,
        snowflakeAccId,
        snowflakeOrgId,
        database,
        warehouse,
    } = destination;

    return http.post('/api/s/_SID_/datasync/destinations', {
        bucketUrl,
        secretKey,
        serviceAccount,
        status,
        type,
        tenantId,
        roleId,
        region,
        provider,
        snowflakeAccId,
        snowflakeOrgId,
        database,
        warehouse,
    });
}

export function createDestinationConfigurations ({ type }) {
    return http.post('/api/s/_SID_/datasync/destination-configurations', { type });
}

export function createExport ({ applicationName, endDate, name, startDate, type, dataType, dataLevel }) {
    return http.post(`/api/s/_SID_/datasync/destinations/Default/${type === 'Test' ? 'test-' : ''}exports`, {
        applicationName,
        endDate,
        name,
        startDate,
        type,
        dataType,
        dataLevel,
    });
}

export function fetchDestination (destinationId) {
    return http.get(`/api/s/_SID_/datasync/destinations/${destinationId}`);
}

export function fetchDestinations () {
    return http.get('/api/s/_SID_/datasync/destinations');
}

export function fetchExport (exportId) {
    return http.get(`/api/s/_SID_/datasync/exports/${exportId}`);
}

export function fetchExportEstimate ({ applicationName, countableList, endDate, startDate, type, dataType, dataLevel }) {
    return http.post('/api/s/_SID_/datasync/export-estimation', {
        applicationName,
        countableList,
        endDate,
        startDate,
        type,
        dataType,
        dataLevel,
    });
}

export function fetchExports (options = {}) {
    const { dataType = 'events', start, end, limit } = options;
    const params = { dataType };

    if (start && end) {
        params.start = start;
        params.end = end;
    }

    if (limit) {
        params.limit = limit;
    }

    return http.get('/api/s/_SID_/datasync/exports', { params });
}

export function fetchExportsByTypeAsSuper (subId = null, type) {
    return http.get(
        subId ? `/api/super/s/${subId}/datasync/exports/${type}` : `/api/super/s/_SID_/datasync/exports/${type}`,
    );
}

export function deleteExportAsSuper ({ exportId, subId }) {
    return http.delete(`/api/super/s/${subId}/datasync/exports/${exportId}`);
}

export function updateDestination (destination) {
    const { id, type } = destination;

    if (type === 'databricks') {
        return http.patch(`/api/s/_SID_/datasync/destinations/${id}`, destination);
    }

    const {
        bucketUrl,
        database,
        secretKey,
        serviceAccount,
        status,
        tenantId,
        roleId,
        provider,
        region,
        snowflakeAccId,
        snowflakeOrgId,
        warehouse,
    } = destination;

    return http.patch(`/api/s/_SID_/datasync/destinations/${id}`, {
        bucketUrl,
        database,
        secretKey,
        serviceAccount,
        status,
        tenantId,
        roleId,
        region,
        provider,
        snowflakeAccId,
        snowflakeOrgId,
        warehouse,
    });
}

export function updateExport ({ id, enabled, startDate }) {
    const payload = { enabled };
    if (startDate !== undefined) payload.startDate = startDate;

    return http.patch(`/api/s/_SID_/datasync/exports/${id}`, payload);
}

export function toDate (dateOrMs) {
    if (!dateOrMs) return null;
    if (dateOrMs instanceof Date) return dateOrMs;

    return new Date(dateOrMs);
}

export function validateDestination (destination) {
    return createDestination({
        ...destination,
        status: 'Validating',
    });
}

export function deleteDestination (id) {
    return http.delete(`/api/s/_SID_/datasync/destinations/${id}`);
}
